import {
    WORKSPACE_SERVICE_URI,
    ANALYTICS_URI,
    INSIGHTS_SERVICE_URI,
    BIO_URI,
    BIO_SERVICE_URI,
    DISCOVERY_SERVICE_URI,
    PAPER_SERVICE_URI,
    LAB_SERVICE_URI,
    ACCOUNT_SERVICE_URI,
    HOME_SERVICE_URI,
    CHEMICAL_SERVICE_URI,
    CHEMICAL_MARVIN_URI,
    EUREKA_SERVICE_URI,
    MARKETPLACE_SERVICE_URI,
    CORE_BASIC_SERVICE_URI,
    CORE_SEARCH_SERVICE_URI,
    DASHBOARD_SERVICE_URI,
    PASSPORT_URI,
} from 'library-@/config/apiConfig';

export const workspaceApiUrlPrefix = `${WORKSPACE_SERVICE_URI}/workspace/web`;
export const workspaceForBioApiUrlPrefix = `${WORKSPACE_SERVICE_URI}/life-science-search-web`;
export const analysisApiUrlPrefix = `${ANALYTICS_URI}/analysis-api/analysis-matrix`;
export const coreAnalysisApiUrlPrefix = `${CORE_BASIC_SERVICE_URI}/analysis-api`;
export const coreBasicApiUrlPrefix = `${CORE_BASIC_SERVICE_URI}/core-basic-api`;
export const coreCopilotApiUrlPrefix = `${CORE_BASIC_SERVICE_URI}/core-copilot-api`;
export const coreSearchApiUrlPrefix = `${CORE_SEARCH_SERVICE_URI}/core-search-api/search`;
export const emailAlertApiUrlPrefix = `${HOME_SERVICE_URI}/email-alert-api`;
export const paperResultApiUrlPrefix = `${PAPER_SERVICE_URI}/paper`;

export const analysisNodeApiUrlPrefix = `${ANALYTICS_URI}/node-internal`;

// urlPrefix不要带后面的 /
export const rdApiUrlPrefix = `${ANALYTICS_URI}/rd-api`;

export const sBasicApiUrlPrefix = `${CORE_BASIC_SERVICE_URI}/core-basic-api`;
export const insightsApiUrlPrefix = `${INSIGHTS_SERVICE_URI}/insights-api/insights-service-v2`;
export const marketplaceApiUrlPrefix = `${MARKETPLACE_SERVICE_URI}/marketplace-api`;
export const lifeScienceApiUrlPrefix = `${BIO_SERVICE_URI || BIO_URI}/life-science-search-web`;
export const discoveryApiUrlPrefix = `${DISCOVERY_SERVICE_URI}/discovery-api`;
export const labServiceApiUrlPrefix = `${LAB_SERVICE_URI}/lab-service`;
export const accountServiceApiUrlPrefix = `${ACCOUNT_SERVICE_URI}/user-service`;

export const paperApiUrlPrefix = `${PAPER_SERVICE_URI}/paper`;
export const accountApiUrlPrefix = `${ACCOUNT_SERVICE_URI}`;
export const homeApiUrlPrefix = `${HOME_SERVICE_URI}/home`;
export const chemicalNodeApiPrefix = `${CHEMICAL_SERVICE_URI}/node-internal`;
export const chemicalUserApiPrefix = `${CHEMICAL_SERVICE_URI}/chemical-user`;
export const chemicalEmailAlertApiPrefix = `${CHEMICAL_SERVICE_URI}/chemical-email-alert`;
export const chemicalMarvinApiPrefix = `${CHEMICAL_MARVIN_URI}`;
export const eurekaApiUrlPrefix = `${EUREKA_SERVICE_URI}/eureka`;
export const dashboardApiUrlPrefix = `${DASHBOARD_SERVICE_URI}`;

export const passportApiUrlPrefix = `${PASSPORT_URI}`;
